/* global $:false Sentry:false */

import AppInfo from './helpers/cob.app-info.js';
import FirstMenuSelectionStrategy from './helpers/cob.startup.js';
import LoadingIndicator from './helpers/cob.loading.js';
import ModelRepository from './helpers/cob.modelrepo.js';
import Modules from './helpers/cob.modules.js';
import PubSub  from './helpers/cob.pubsub.js';
import Routing from './helpers/cob.routing.js';
import Security from './helpers/cob.security.js';
import Templator from './helpers/cob.templator.js';
import Translator from './helpers/cob.translator.js';
import VersionChecker from './helpers/cob.versionchecker.js';

import _html_forbidden from 'raw-loader!./parts/forbidden.html';
import _html_main from 'raw-loader!./parts/main.html';

import authModule from './modules/cob.auth.js';
import forbiddenModule from './modules/cob.forbidden.js';
import menuModule from './modules/cob.menu.js';

import ui from './cob.ui.js';
import utils from './cob.utils.js';

//Initialize our app
var app = (function() {

    //## _Private_ Vars

    var
    // The object where we add _public_ methods
        exports = {},

    //The app settings
        settings = {
            //the operating mode of the app - normal or naked
            mode: function(){
                return "normal";
            }
        },

    // ### Models

    // ### _Pseudo_ Modules

    // A pseudo-module that deals with logging in the user. An instance of `cob.auth`
        _auth = {
            uri: ['/login'],
            pseudoModule: true,
            // it means that will be the only one running. All the others modules should be stopped.
            exclusive: true,
            name: "cob.auth",
            constructor: authModule
        },

    // A pseudo-module that shows an error if the user tries to access a forbidden page.
    // An instance of `CoB.Forbidden`
        _forbidden = {
            uri: ['/forbidden'],
            pseudoModule: true,
            exclusive: true,
            name: "cob.forbidden",
            constructor: forbiddenModule
        },

    // A pseudo-module that manages the app's menu. An instance of `cob.menu`
        _menu = {
            name: "cob.menu",
            pseudoModule: true,
            constructor: menuModule
        },

    // ### Helpers

    // Our app's internal event bus.
        bus = new PubSub({
           deprecatedEvents: {
              'recordm:walkthrough:entity': 'definition-search:results-ready',
              'recordm:walkthrough:unified-search-results': 'unified-search:results-ready'
           }
        }),

    // An instance of `CoB.Security`. Loads perms and can test for them.
        _security = new Security(exports),

    // An instance of `CoB.Templates`. Compiles and applies templates
        _templates = new Templator(),

    // An instace of `CoB.Translator`. Loads the user prefered language and translates strings and _DOM_ elements.
        _translator = new Translator(
           (new URL(document.location)).searchParams.get("lang"),
           (new URL(document.location)).searchParams.get("locale")
        ),

    // An instance of the `cob.LoadingIndicator`
        _loading = new LoadingIndicator(
            // A `cob.utils.ZeroLatch` that controls hiding and showing the loading indicator.
            // When it's not at the _zero state_, the "Loading" indicator is shown.
            new utils.ZeroLatch(
                function() {
                    $('#loading').show();
                },
                function() {
                    $('#loading').hide();
                },
                "loading indicator"
            )
        ),
    // The key for interacting with cob.Loading
        _loadingKey = _loading.getLoadingKey(),

    // An instance of the `cob.ModelRepository` for model sharing between presenters
        _modelRepo = new ModelRepository(),

    // An instance of `cob.AppInfo`. Loads the menu items and the name of the current user.
        _appInfo = new AppInfo(exports),

    // the default strategy to use in our apps
        moduleSelectionConf = {loginUri: _auth.uri[0], forbiddenUri: _forbidden.uri[0]},
        moduleSelectionStrategy = new FirstMenuSelectionStrategy(exports, moduleSelectionConf),

    // An instance of the `cob.Routing`
        _routing = new Routing(exports, {
            goTo: function(moduleName, args, stateId, hash) {
                var success,
                    isAnonymousUser;

                // If it is the login or the forbidden handle it as soon as possible.
                // There is no need to let the `_modules` return false when processing.
                if (moduleName === _auth.name || moduleName === _forbidden.name) {

                    if (moduleName === _auth.name && _appInfo.isCasEnabled()) {
                        _routing.navigateToCasLogin(_appInfo.getBaseUrlForCas());
                        return;
                    }

                    if (moduleName === _forbidden.name) {
                        _modules.pauseActiveModule();
                    }

                    _pseudoModules.goToModule(moduleName, undefined, moduleName, true);
                    return;
                }

                success = _modules.goToModule(moduleName, args, stateId, false, hash);
                isAnonymousUser = (_appInfo.getCurrentLoggedInUser() === "anonymous");

                if (success) {
                    // todo jone isto não está a funcionar à algum tempo...
                    // we tell the menu to mark this as the current module
                    _pseudoModules.goToModule('cob.menu', [moduleName], 'cob.menu', true);

                    //someday jone isto podia ser gerado por cada módulo, para ser mais interessante...
                    window.document.title = window.document.title.replace(/ *\[[^\]]*\]/, "") + " [" + moduleName + "]";

                } else {
                    if (isAnonymousUser) {
                        if(_appInfo.isCasEnabled()){
                            _routing.navigateToCasLogin(_appInfo.getBaseUrlForCas());
                        } else{
                            _pseudoModules.goToModule('cob.auth', undefined, 'cob.auth', true);
                        }

                    } else {
                        _pseudoModules.goToModule('cob.forbidden', undefined, 'cob.forbidden', true);

                    }
                }
            },
            getDefaultModuleUri: moduleSelectionStrategy.getDefaultModuleUri
        }),

    // An instance of the `cob.Modules`
        _modules = new Modules(exports, _routing, _security, _loading),

    // An instance of the `cob.Modules`
        _pseudoModules = new Modules(exports, _routing, _security, _loading),

    // ### Misc

    // A **hack** used by some modules to generate _locally unique_ Ids.
    //The cannonical example are the field Ids in RecordM.
        bogusId = -100000000,

    //This will be true if we are inside an `iframe`. This has happened with Recordm inside Sigre.
        _inIframe = window.self !== window.parent,

    // this will be true if the user's running a supported browser (IE8+, Mozilla ou Webkit)
        _isSupportedBrowser = (($.browser.msie && $.browser.version > 7.0) ||
                               ($.browser.mozilla) ||
                               ($.browser.webkit));

    // ## Low-level setup

    //Prevent the default browser behaviour of openning files that are _drag-n-droped_ on it.
    // jnelas: comentei porque impedia selecção de texto com o rato na nova versão, não sei porquê a diferença
    // $(document).bind('dragend dragleave dragover drop', function(e) {
    //     e.preventDefault();
    // });

    // setup jQuery ajax
    $.ajaxSetup({
        // we wan't a long timeout, because our backend can be slow....
        timeout: 30000,
        // we still have no cache control, so let's disable it
        cache: false
    });

    // ## App Start

    // ### Initiate app version change detection (if not running locally for dev)

    if(window.location.hostname !== 'localhost') VersionChecker.startCheckingServerVersion(_appInfo);

    // ### Resource loading

    // Latch that triggers when the configuration props have been loaded.

    var appInfoLatch = new utils.CountdownLatch(1, function() {
        bus.publish("app:config-props-loaded");
    }, "appInfoLatch");


    // load the appInfo
    _appInfo.updateAppInfo(function() {

        //append the app root div to the body as soon as we have its id
        var appInstId = _appInfo.getAppInfoModel().appInstanceId;
        if(!document.getElementById(appInstId)){
            window.console.log("Creating root div element for the app (div id="+ appInstId+")");
            $('body').append('<div id="'+appInstId+'" class="cob-app"></div>');
        }

        appInfoLatch.countDown("_appInfo.update");
        bus.publish("app:appInfo:model-loaded");

    });

    // Latch that triggers when all the resources have been loaded.
    // It only publishes an event, because `_loadModules` will add a callback
    // that initializes the modules.

    var resourcesLatch = new utils.CountdownLatch(2, function() {
        bus.publish("app:resources-loaded");
    }, "resourcesLatch");

    appInfoLatch.addCallback(function() {
        // Load the user's prefered language
        _translator.loadLanguage(function() {

            if (typeof Sentry !== 'undefined') Sentry.configureScope((scope) => { scope.setTag("language", _translator.getLanguage()) });

            resourcesLatch.countDown("_translator.loadLanguage");
            bus.publish("app:translator:language-loaded");
        });

        // load the user's permissions
        _security.loadPerms(function() {
            resourcesLatch.countDown("_security.loadPerms");
            bus.publish("app:security:perms-loaded");
        });

        //we want the core-parts (mostly the menu) to be at the top of the body
        $('#'+_appInfo.getAppInfoModel().appInstanceId).prepend(_html_main, _html_forbidden);
    });

    // ### App init
    // moduleList: the list of module objects to initialize
    // opts: optional app initialization settings ?
    var _init = function(moduleList, opts) {

        if (opts) {
            utils.extend(settings, opts, true);

            if (opts.getDefaultModuleUri) moduleSelectionStrategy.overrideWith(opts.getDefaultModuleUri);

            /* eslint-disable-next-line  */
            if(typeof Sentry !== 'undefined') Sentry.configureScope((scope) => {
                scope.setTag("version", settings.app_version);
            });
        }

        // we add a callback to the `resourceLatch`,
        // it works even if it has already countdown zero.
        resourcesLatch.addCallback(function() {
            exports.showLoading(_loadingKey, "_init");

            _modules.registerModules(moduleList);
            _pseudoModules.registerModules([ _auth, _forbidden, _menu ]);

            _turnOnGlobalErrorHandler();

            _translateApp(function() {

                // Clear the stack that holds the modules that I have been to
                _modules.resetModules();

                //Start listenning for hash changes after we initialized all the modules.
                //We need to do this when we access the page for the first time.
                _routing.start(settings.routingBaseSelector);

                exports.hideLoading(_loadingKey, "_init");
            });
        });
    };

    var _loginAs = function(selectedUsername){

        //If the logged in user is now impersonating the selected user
        //we redirect him/her to the application "homepage".
        _security.loginAs(selectedUsername, {
            success: _routing.navigateToAppHomepage,
            error: function(req){
                window.console.log("login-as:error: " + req.status + " : " + req.statusText + ":" + req.responseText);
            }
        });
    };

    // We have a global ajax error handler that show errors to the user,
    // using `cob.ui.notification`, and triggers the login if the user is not authenticated.
    // It should only be called after `_initPseudoModules` that start the `auth` _pseudo_ module.
    var _turnOnGlobalErrorHandler = function() {
        // Register a global Ajax error listener that notifies the user
        // when we can't talk to the server, or the user is unauthorized.
        // Also, trigger the login process when we receive a 401 from the server.
        $(document).ajaxError(function(e, jqxhr, settings) {

            //a specific request can set `ignoreErrors` to true to skip our behaviour.
            if (settings.ignoreErrors) return;

            if (jqxhr.status === 0) {
                window.console.log("The server is probably down!");
                ui.notification.notifyServerDown();

                // We are unauthorized
            } else if (jqxhr.status === 403) {
                window.console.log("you can't touch this");
                _modules.pauseActiveModule();
                _pseudoModules.goToModule('cob.forbidden', undefined, 'cob.forbidden', true);

                // We are not authenticated
            } else if (jqxhr.status === 401) {
                window.console.log("you are not authenticated");

                _loading.reset("status 401 authenticating user");

                _pseudoModules.goToModule('cob.auth', undefined, 'cob.auth', true);
            }
        });
    };

     // ## End of App start

    // ### Translation

    // Translate the app's body.
    // Should be called only **after** all the modules have finished `init()`.
    var _translateApp = function(cb) {
        _translator.translate('cob.app', '#'+_appInfo.getAppInfoModel().appInstanceId, true, function(data) {
            document.title = data["app-name"];
            $('.header .title').text(data["app-name"]);

            cb();
        });
    };

    var _logout =  function(){
        var casUrl = _appInfo.getBaseUrlForCas();

        _security.logout(function() {
            _loading.reset("user logged out");

            _resetAppData(function() {
                _appInfo.resetInfo();
                _modules.resetModules();

                if(casUrl !== undefined){
                    _routing.navigateToCasLogout(casUrl);

                }else{
                    _routing.changeRouteWithoutNavigation("/");
                    _pseudoModules.goToModule('cob.auth', undefined, 'cob.auth', true);
                }
            });
        });
    };

    // Clears the model repo and reloads all the user and security information.
    var _resetAppData = function(onDone) {
        _modelRepo.resetRepo();
        _modules.resetModules();

        var refreshUserLatch = new utils.CountdownLatch(2, function() {
            if (onDone && typeof onDone === 'function') onDone();
        }, "refreshUserLatch");

        _appInfo.updateAppInfo(refreshUserLatch.countDown);
        _security.loadPerms(refreshUserLatch.countDown);
    };

    var $body = $('body');

    // set a global logout link listener
    $body.on('click', '.js-logout', function(e) {
        e.preventDefault();

       _logout();
    });

    // set a global end impersonation link listener
    $body.on('click', 'a.js-reset-user', function(e) {
        e.preventDefault();

        _security.resetUser({
            success: function(){
                window.location = "/";
            },
            error: function(req){
                window.console.log("reset-user:error: " + req.status + " : " + req.statusText + ":" + req.responseText);
                _logout();
            }
        });
    });

    bus.subscribe("app:security:user-changed", function() {
        // Clear the loading latch (hidding "please wait" message)
        _loading.reset("user changed");

        _resetAppData(function() {
            // we'll go on to the original destination
            _routing.navigateToCurrentRoute();
        });
    });

    //## _Public_ functions

    // we _export_ the event bus _public_ methods
    utils.extend(exports, bus);

    utils.extend(exports, _modules);

    // we _export_ the model repository _public_ methods
    utils.extend(exports, _modelRepo);

    // we _export_ the routing _public_methods
    utils.extend(exports, _routing);

    // we _export_ the loadingIndicator _public_methods
    utils.extend(exports, _loading);

    // we _export_ the templates _public_methods
    utils.extend(exports, _templates);

    // we _export_ the translator _public_methods
    utils.extend(exports, _translator);

    // we _export_ the translator _public_methods
    utils.extend(exports, _appInfo);

    utils.extend(exports, {
        init: _init,

        hasPermission: _security.hasPermission,

        login: _security.login,

        loginAs: _loginAs,

        templateApply: _templates.apply,

        locallyUniqueId: function() {
            return bogusId -= 1;
        },

        isInIframe: function() {
            return _inIframe;
        },

        isSupportedBrowser: function() {
            return _isSupportedBrowser;
        },

        getSettings: function(){
            return settings;
        },

        getAppMode: function(){
            return settings.mode();
        },

        getAppInstanceId: function(){
            return _appInfo.getAppInfoModel().appInstanceId;
        },

        removeCobStyleFromCUI:function (){
            var hash = window.location.hash || '' ;
            var pageName = hash.substring(0, hash.indexOf('?')).substring(hash.lastIndexOf('/')+1) || '';
            var el = document.getElementById(pageName);
            if(el){
                el.classList.remove("cob-app");
                window.console.log("Cob style cob-app removed from " + pageName);
            }else{
                window.console.warn("No element found for CUI with id "+ pageName);
            }
        }

    });

    return exports;
}());

export default app;
